export const ASSETS_BASE_URL = '/assets/images'
export const TEMPLATES_BASE_URL = '/assets/templates'
export const CONFIRMATION_DELETE_WORD = 'DELETE'
export const BULK_DELETE_CONFIRMATION_WORD = 'DELETE ALL'
export const ALVIE_SUPPORT_EMAIL = 'info@alvie.io'

export const ALVIE_HELP_CENTER_URL = 'https://help.alvie.io/en/'

export const COPY_CONFIG_PREFIX = 'Copy of '

export const POPUP_QUERY_PARAMETER_KEY = 'popup'
export const CONFIG_ID_QUERY_PARAMETER_KEY = 'configId'
export const EVENT_DAG_POPUP_TEXT = 'eventDag'
export const TRANSACTION_ID_QUERY_PARAMETER_KEY = 'transactionId'

export * from './analytics'
